/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Userview from '../../Userview/Userview';
import Fab from '../../Fab/Fab';
import Service from '../../Util/Service';
import $ from '../../Util/Util';
import AddIcon from './baseline_add_white_24dp.png';
import './Users.css';

/**
 * Represents the user maintenance screen.
 */

export default class Users extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        onUserSelected:              PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        users:      [],
        user:       null
    }

    /**
     * Loads the users.
     */

    _refresh = () => {

        // Showing the progress indicator

        this.props.onLoading(true);

        // Loading the users

        Service.loadUser().then((users) => {
            
            // Storing the users

            this.setState({ users: users });

            // Hiding the progress indicator

            this.props.onLoading(false);
        }).catch((error) => {

            // Hiding the progress indicator

            this.props.onLoading(false);

            // Showing error

            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
        });
    }

    /**
     * Events that fires when the user selects a user from the list.
     * 
     * @param   {Object}    user        selected user
     */

    _userSelected = (user) => {

        // Do nothing if there is no UID of the selected user

        if (this.state.user && !this.state.user.uid ) {
            return;
        }

        // Storing the selected user

        if (this.props.context.environment.browser.info.mobile) {
            this.props.onUserSelected(user);
        } else {
            this.setState({ user: (this.state.user && this.state.user.uid === user.uid) ? null : user }, () => {
                if (this.userview) {
                    this.userview.refresh(this.state.user);
                }                
            });
        }
    }

    /**
     * Adds a new user.
     */

    _addNewUser = () => {

        // Creating the user

        let user = {
            name:   this.props.context.locale.user.newuser,
            email:  this.props.context.locale.user.newemail,
            new:    true,
            active: true
        };

        // Storing the user

        if (this.props.context.environment.browser.info.mobile) {
            this.props.onUserSelected(user);
        } else {
            this.setState({ user: user }, () => {
                this.userview.refresh(this.state.user);
            });
        }
    }

    /**
     * Event that fires when the user closes the user maintenance.
     * 
     * @param   {Boolean}   refresh     refreshing the users
     */

    _onCloseMaintenance = (refresh) => {

        // Clearing the users

        this.setState( { user: null });

        // Refreshing the users
        
        if (refresh) {
            this._refresh();
        }
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.user.title);

        // Refreshing the users

        this._refresh();
    }

    /** 
     * User maintenance screen renderer.
     */

    render() {
        return (
            <div className="users">

                {/* User container */}

                <div className="users-container horizontal">

                    {/* List of users */}

                    <div className="users-list vertical" style={{ height: (this.props.context.environment.screen.usefullheight - 32) + 'px' }}>
                        { this.state.users.map((item, index) =>
                            <div key={index} className={`users-user ${(this.state.user && this.state.user.uid === item.uid) ? 'users-user-selected' : 'users-user-unselected'}`} onClick={this._userSelected.bind(this, item)}>{item.name}</div>
                        )}

                        {/* Add new user */}

                        { !this.state.user && <div className="users-fab">
                            <Fab icon={AddIcon} tooltip={this.props.context.locale.user.newusertooltip} onTouch={this._addNewUser} />
                        </div> }
                    </div>

                    {/* Maintenance */}

                    { !this.props.context.environment.browser.info.mobile && this.state.user && <div className="users-maintenance">
                        <Userview ref={c => {this.userview = c;}} context={this.props.context} onLoading={this.props.onLoading} onClose={this._onCloseMaintenance} />
                    </div> }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Users/Users.js